import useFetcher from "common/hooks/useFetcher";
import React, { useState } from "react";
import EditorTable from "common/components/Table/editor";
import { Stack } from "@mui/material";
import toast from "react-hot-toast";
export default function SheetEditor({ id, item, close }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetcher = useFetcher();
  const loadSheet = async () => {
    setLoading(true);
    await fetcher.get(
      "fetching sheet data",
      `/api/sys/${id}/sheet?key=${encodeURI(item?.key)}`,
      ({ data }) => {
        setData(data);
      },
      () => {}
    );
    setLoading(false);
  };
  const saveSheet = async (data) => {
    await fetcher.put(
      "saving sheet",
      `/api/sys/${id}/sheet?key=${encodeURI(item?.key)}`,
      { data },
      ({ error }) => {
        if (error) return toast.error(error);
        close();
      },
      () => {}
    );
  };
  React.useEffect(() => {
    if (!item) return;
    loadSheet();
  }, [item]);
  return (
    <Stack m={2}>
      <EditorTable
        loading={loading}
        data={data}
        close={close}
        save={saveSheet}
      />
    </Stack>
  );
}
